import script from "./ProductDetailAdditionalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailAdditionalInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailAdditionalInfo.vue?vue&type=style&index=0&id=34661551&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34661551"]])

export default __exports__